import React, { FunctionComponent, useState, useContext } from "react";
import styles from "./EndorsementCard.module.scss";
import { AddRounded, DoneRounded } from "@material-ui/icons";
import cn from "classnames";
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "shared/components/Modal/Modal";
import apiCalls from "shared/utils/apiCalls";
import AppContext from "context/AppContext";
import CardUser from "shared/components/CardUser/CardUser";
import Button from "shared/components/Buttons/Button";
import Skeleton from "@material-ui/lab/Skeleton";

const EndorsementCard: FunctionComponent<{
  skillId?: string;
  skill: string;
  endorsements: string[];
  onClick?: () => any;
  borderBottom?: boolean;
  disable?: boolean;
  loading?: boolean;
  endorsed?: boolean;
}> = ({
  skillId,
  skill,
  endorsements,
  onClick,
  borderBottom = true,
  disable,
  loading,
  endorsed,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const { dispatch } = useContext(AppContext);
  const [endorsementUsers, setEndorsementUsers] = useState<any>();
  const [userLoading, setUserLoading] = useState<boolean>(false);

  const getEndorsementUsers = async () => {
    if (!skillId) {
      return;
    }

    setUserLoading(true);

    const res = await apiCalls(
      {
        method: "get",
        url: `/skills/${skillId}/users`,
      },
      dispatch
    );

    if (res) {
      setEndorsementUsers(res.data);
    }
    setUserLoading(false);
  };

  const openUsersModal = async () => {
    setOpen(true);
    if (!endorsementUsers) {
      getEndorsementUsers();
    }
  };

  return (
    <div
      className={cn(styles.skillsAndEndorsements_card, {
        [styles.skillsAndEndorsements_card_borderBottom]: borderBottom,
      })}
    >
      <Modal open={open} closeModal={() => setOpen(false)} size="sm" scrollable>
        <h4 style={{ marginBottom: "var(--space-2xs)" }}>
          Endorsements for {skill}
        </h4>

        {!userLoading && (
          <div>
            {endorsementUsers?.map((user: any) => (
              <div
                style={{ margin: "var(--space-sm) 0" }}
                id={user.id}
                key={user?.id}
              >
                <CardUser user={user} />
              </div>
            ))}
          </div>
        )}

        {userLoading &&
          [0, 1, 2, 3].map((number) => <Skeleton key={number} height={60} />)}

        <div className={styles.skillsAndEndorsements_card_modal_buttonRow}>
          <Button
            aria-label="done"
            buttonVariant="secondary"
            onClick={() => setOpen(false)}
          >
            Ok
          </Button>
        </div>
      </Modal>

      <button
        className={cn(styles.skillsAndEndorsements_card_endorseButton, {
          [styles.skillsAndEndorsements_card_endorseButton__disable]: disable,
          [styles.skillsAndEndorsements_card_endorseButton__endorsed]: endorsed,
        })}
        aria-label="add skill"
        disabled={!!disable || loading}
        onClick={onClick}
      >
        {loading ? (
          <CircularProgress size={18} thickness={5} />
        ) : endorsed ? (
          <DoneRounded fontSize="small" />
        ) : (
          <AddRounded fontSize="small" />
        )}
      </button>
      <div className={styles.skillsAndEndorsements_card_description}>
        <div className={styles.skillsAndEndorsements_card_skill}>
          <div className={styles.skillsAndEndorsements_card_skill_label}>
            {skill}
          </div>
        </div>

        {endorsements?.length > 0 && (
          <button
            className={styles.skillsAndEndorsements_card_message}
            onClick={openUsersModal}
            disabled={endorsements?.length <= 0}
            aria-label="endorsements"
          >
            {endorsements?.length} endorsements
          </button>
        )}
      </div>
    </div>
  );
};

export default EndorsementCard;
